import create from 'skytech-vue2-form-core';

const { single } = create({ get: null });

export default single;
